/* Ascari Cities — behaviours for the ascari-* sections.
   Scroll effects (progress, header, word reveal, parallax, marquee), the
   strap selectors and the sticky buy bar. Add to cart goes through the
   Shopify Ajax Cart API and opens the theme's own cart drawer: Motion /
   Archetype themes via the ajaxProduct:added event, Dawn-family themes via
   <cart-drawer>.renderContents(); otherwise the cart page.
   Re-initialises when sections reload in the theme editor. */
(() => {
  if (window.AscariCities) return;

  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const designMode = () => !!(window.Shopify && Shopify.designMode);
  const txt = n => [...n.childNodes].filter(x => x.nodeType === 3).map(x => x.textContent).join('').trim();
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);
  const cardOf = k => document.getElementById('buy-' + k);

  const state = { city: null };
  const bb = { city: null, manual: false };
  let cfg = {};
  let el = {};
  let lastY = scrollY, vel = 0;

  /* ---------- theme cart ---------- */
  // Motion (Archetype Themes): its CartDrawer listens for "ajaxProduct:added" on
  // document, then rebuilds and opens itself; theme.settings.cartType may be "page".
  const motion = () => (window.theme && theme.settings && 'cartType' in theme.settings ? theme : null);
  // Dawn family: <cart-drawer>/<cart-notification> with getSectionsToRender()/renderContents().
  const dawnCart = () => {
    const c = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    return c && typeof c.renderContents === 'function' && typeof c.getSectionsToRender === 'function' ? c : null;
  };
  const cartAddUrl = () => (motion() && theme.routes && theme.routes.cartAdd)
    || ((window.routes && window.routes.cart_add_url) || ROOT + 'cart/add') + '.js';
  const cartPageUrl = () => (motion() && theme.routes && theme.routes.cartPage)
    || (window.routes && window.routes.cart_url) || ROOT + 'cart';

  // Motion's own product form dispatches ajaxProduct:added from a <form> holding
  // the variant input; other Motion listeners read [name="id"] from the event
  // target, so dispatch from the same shape of element.
  function motionAdded(product, btn) {
    let f = document.getElementById('AscariCartEvents');
    if (!f) {
      f = document.createElement('form');
      f.id = 'AscariCartEvents';
      f.hidden = true;
      f.innerHTML = '<input type="hidden" name="id">';
      document.body.appendChild(f);
    }
    f.querySelector('[name="id"]').value = product.variant_id || product.id || '';
    f.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product, addToCartBtn: btn }, bubbles: true }));
  }

  /* ---------- cards ---------- */
  function cardItem(c) {
    const segOn = $('.seg button[aria-checked="true"]', c);
    const id = segOn ? segOn.dataset.variantId : c.dataset.variantId;
    const available = (segOn ? segOn.dataset.available : c.dataset.available) !== 'false';
    const label = segOn ? txt(segOn) : (($('.price small', c) || {}).textContent || '').trim();
    return { id, available, name: $('h3', c).textContent.trim(), optLabel: cap(label) };
  }

  function chooseSeg(card, b) {
    $$('.seg button', card).forEach(x => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
    const out = $('[data-out]', card), note = $('[data-note]', card);
    if (out) out.textContent = $('b', b).textContent.trim();
    if (note) note.textContent = 'on ' + txt(b).toLowerCase();
    const a = $('[data-shop]', card);
    if (a && b.dataset.url) a.href = b.dataset.url;
    card.classList.toggle('is-strap', b.dataset.opt === 'strap');
  }

  function bindCards() {
    $$('.ascari .buy').forEach(card => {
      if (card.dataset.bound) return;
      card.dataset.bound = '1';
      $$('.seg button', card).forEach(b => b.addEventListener('click', () => { chooseSeg(card, b); bbRender(); }));
      const on = $('.seg button[aria-checked="true"]', card);
      if (on) chooseSeg(card, on);
      $$('.view-tog button', card).forEach(b => b.addEventListener('click', () => {
        $$('.view-tog button', card).forEach(x => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
        card.classList.toggle('is-strap', b.dataset.view === 'strap');
        bbRender();
      }));
    });
    $$('.ascari [data-pick]').forEach(a => {
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', () => {
        const c = cardOf(a.dataset.pick);
        if (!c) return;
        c.classList.add('flash');
        setTimeout(() => c.classList.remove('flash'), 1600);
      });
    });
    $$('.ascari .cart-btn').forEach(b => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', e => { e.preventDefault(); addToCart(b.dataset.add === 'bb' ? bb.city : b.dataset.add, b); });
    });
    $$('.ascari .cu-frame').forEach(f => {
      if (f.dataset.bound) return;
      f.dataset.bound = '1';
      f.addEventListener('pointermove', e => {
        const r = f.getBoundingClientRect();
        f.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        f.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
    if (FINE && !RM) $$('.ascari .magnetic').forEach(m => {
      if (m.dataset.bound) return;
      m.dataset.bound = '1';
      m.addEventListener('pointermove', e => {
        const r = m.getBoundingClientRect();
        m.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .25}px,${(e.clientY - r.top - r.height / 2) * .35}px)`;
      });
      m.addEventListener('pointerleave', () => { m.style.transform = ''; });
    });
  }

  /* ---------- buy bar ---------- */
  const cardImg = c => {
    const strap = c.classList.contains('is-strap') && $('.strap-img', c);
    const img = strap || $('.bracelet-img', c) || $('.buy-media img', c);
    return img ? (img.currentSrc || img.src) : '';
  };

  function bbBuild() {
    const box = el.bar && $('[data-bb-watches]', el.bar);
    if (!box) return;
    box.innerHTML = '';
    $$('.ascari .buy').forEach(c => {
      const k = c.dataset.world, b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.dataset.k = k;
      b.innerHTML = '<i></i><span></span>';
      b.querySelector('i').style.setProperty('--c', c.dataset.dot || '#888');
      b.querySelector('span').textContent = $('h3', c).textContent.trim().replace(/^Ascari\s+/i, '');
      b.addEventListener('click', () => { bb.manual = true; bbSet(k); });
      box.appendChild(b);
    });
    if (!bb.city || !cardOf(bb.city)) bb.city = ($('.ascari .buy') || {}).dataset?.world || null;
  }

  function bbRender() {
    const c = bb.city && cardOf(bb.city);
    if (!el.bar || !c) return;
    $$('[data-bb-watches] button', el.bar).forEach(b => b.setAttribute('aria-checked', b.dataset.k === bb.city ? 'true' : 'false'));
    const cs = getComputedStyle(c);
    el.bar.style.setProperty('--bbc', cs.getPropertyValue('--c'));
    el.bar.style.setProperty('--bbk', c.dataset.dot || cs.getPropertyValue('--k'));
    const thumb = $('[data-bb-img]', el.bar);
    if (thumb) thumb.src = cardImg(c);
    const seg = $$('.seg button', c), box = $('[data-bb-opts]', el.bar);
    box.innerHTML = '';
    if (seg.length) {
      box.className = 'bb-opts';
      box.setAttribute('role', 'radiogroup');
      box.setAttribute('aria-label', 'Strap');
      seg.forEach(sb => {
        const o = document.createElement('button');
        o.type = 'button';
        o.setAttribute('role', 'radio');
        o.setAttribute('aria-checked', sb.getAttribute('aria-checked'));
        o.append(sb.dataset.barLabel || txt(sb));
        const pb = document.createElement('b');
        pb.textContent = $('b', sb).textContent.trim();
        o.appendChild(pb);
        o.addEventListener('click', () => sb.click());
        box.appendChild(o);
      });
    } else {
      box.className = 'bb-gift';
      box.removeAttribute('role');
      box.removeAttribute('aria-label');
      const g = $('.gift b', c);
      box.innerHTML = '<i>+</i><span></span>';
      box.querySelector('span').textContent = g ? g.textContent.trim() : (($('.price small', c) || {}).textContent || '').trim();
    }
    const out = $('[data-out]', c) || $('.price b', c);
    $('[data-bb-price]', el.bar).textContent = out ? out.textContent.trim() : '';
  }

  function bbSet(k) { bb.city = k; bbRender(); }

  function toast(msg) {
    const t = el.toast;
    if (!t) return;
    $('span', t).textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('show'), 3200);
  }

  function pop(btn) {
    if (!btn) return;
    btn.classList.remove('added');
    void btn.offsetWidth;
    btn.classList.add('added');
    setTimeout(() => btn.classList.remove('added'), 1300);
  }

  async function addToCart(k, btn) {
    const c = cardOf(k);
    if (!c) return;
    const item = cardItem(c);
    if (!item.id) { toast(cfg.notConnected); return; }
    if (!item.available) { toast(cfg.soldOut); return; }
    const m = motion();
    const dawn = m ? null : dawnCart();
    const body = { id: +item.id, quantity: 1 };
    if (dawn) {
      // Same request Dawn's product form makes, so the drawer gets its re-rendered sections.
      body.sections = dawn.getSectionsToRender().map(s => s.id);
      body.sections_url = location.pathname;
      if (btn && dawn.setActiveElement) dawn.setActiveElement(btn);
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      pop(btn);
      document.dispatchEvent(new CustomEvent('ascari:cart-added', { detail: data }));
      if (m) {
        if (m.settings.cartType === 'page') { location.href = cartPageUrl(); return; }
        motionAdded(data, btn);
      } else if (dawn) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ascari-cities', productVariantId: item.id, cartData: data });
        }
        dawn.classList.remove('is-empty');
        dawn.renderContents(data);
      } else {
        location.href = cartPageUrl();
      }
    } catch (e) {
      toast(e.description || e.message || cfg.error);
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  }

  function bindPortal() {
    const p = $('.ascari [data-ascari-portal]:not(.is-mounted)');
    if (p) {
      $$('body > .ascari-portal.is-mounted').forEach(x => x.remove());
      p.classList.add('is-mounted');
      document.body.appendChild(p);
    }
    const m = $('body > .ascari-portal.is-mounted');
    el.toast = m && $('.cart-toast', m);
  }

  // Hide the sticky buy bar only while the theme's cart drawer is open, so the
  // drawer's checkout button isn't covered. Motion: #CartDrawer.drawer--is-open
  // (the nav drawer shares html.js-drawer-open, so that class isn't used);
  // Dawn: <cart-drawer class="active">.
  function watchCartDrawer() {
    const d = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!d || d.dataset.ascariWatched) return;
    d.dataset.ascariWatched = '1';
    const sync = () => document.documentElement.classList.toggle('ascari-cart-open',
      d.classList.contains('drawer--is-open') || d.classList.contains('active'));
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  // Route map: pins fade in once the map is a quarter visible; the plane
  // (SMIL animateMotion) is paused for reduced-motion visitors.
  function bindRoutemaps() {
    $$('.ascari [data-ascari-routemap]').forEach(rm => {
      if (rm.dataset.bound) return;
      rm.dataset.bound = '1';
      const svg = $('svg', rm);
      if (svg && RM && svg.pauseAnimations) svg.pauseAnimations();
      if (designMode() || !('IntersectionObserver' in window)) { rm.classList.add('in'); return; }
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { rm.classList.add('in'); io.disconnect(); }
      }), { threshold: .25 });
      io.observe(rm);
    });
  }

  /* ---------- scroll effects ---------- */
  function onScroll() {
    const y = scrollY, h = document.documentElement.scrollHeight - innerHeight, vh = innerHeight;
    if (el.prog) el.prog.style.transform = `scaleX(${h > 0 ? y / h : 0})`;
    if (el.headSec) el.headSec.classList.toggle('ascari-hide', y > lastY && y > 400 && !designMode());
    vel = Math.min(30, Math.abs(y - lastY));
    lastY = y;

    el.reveals.forEach(rt => {
      const words = $$('.w', rt), r = rt.getBoundingClientRect();
      const t = (vh * .85 - r.top) / (r.height + vh * .35);
      const on = Math.floor(Math.max(0, Math.min(1, t)) * words.length * 1.05);
      words.forEach((w, i) => w.classList.toggle('on', RM || designMode() || i < on));
    });

    el.chapters.forEach(ch => {
      const b = ch.getBoundingClientRect();
      if (b.bottom < 0 || b.top > vh) return;
      const img = $('img', ch);
      if (!RM && img) img.style.setProperty('--py', (((b.top + b.height / 2 - vh / 2) / vh) * -60).toFixed(1) + 'px');
      if (b.top < vh * .5 && b.bottom > vh * .5) {
        state.city = ch.dataset.world;
        if (el.prog) el.prog.style.setProperty('--world-ink', getComputedStyle(ch).getPropertyValue('--cink'));
      }
    });

    if (el.bar) {
      const sb = el.shop ? el.shop.getBoundingClientRect().bottom : vh * .8 - y;
      el.bar.classList.toggle('show', !!$('.ascari .buy') && sb < 0);
      if (!bb.manual && state.city && state.city !== bb.city && cardOf(state.city)) bbSet(state.city);
    }
  }

  function marqueeLoop() {
    el.tracks.forEach(tr => {
      const w = tr.scrollWidth / 2;
      tr._x = (tr._x || 0) - (0.6 + vel * .35);
      if (-tr._x >= w) tr._x += w;
      tr.style.transform = `translate3d(${tr._x}px,0,0)`;
    });
    vel *= .92;
    requestAnimationFrame(marqueeLoop);
  }

  /* ---------- init ---------- */
  function init() {
    const conf = $('.ascari [data-ascari-config]') || $('[data-ascari-config]');
    const d = conf ? conf.dataset : {};
    cfg = {
      notConnected: d.notConnected || 'Select a product for this watch in the theme editor',
      soldOut: d.soldOut || 'Sold out', error: d.error || 'Something went wrong'
    };
    const head = $('.ascari [data-ascari-head]');
    el.headSec = head ? (head.closest('.shopify-section') || null) : null;
    el.prog = $('.ascari [data-ascari-progress]');
    el.bar = $('.ascari [data-ascari-buybar]');
    el.shop = $('.ascari [data-ascari-shop]');
    el.reveals = $$('.ascari [data-ascari-reveal]');
    el.chapters = $$('.ascari .chapter');
    el.tracks = $$('.ascari [data-ascari-marquee]');
    el.chapters.forEach((c, i) => c.classList.toggle('flip', i % 2 === 1));
    bindPortal();
    watchCartDrawer();
    bindRoutemaps();
    bindCards();
    bbBuild();
    bbRender();
    onScroll();
  }

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:block:select', 'shopify:block:deselect']
    .forEach(ev => document.addEventListener(ev, () => setTimeout(init, 0)));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (!RM) requestAnimationFrame(marqueeLoop);

  window.AscariCities = { init, addToCart };
})();
